import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";
import PATHS from "shared/constants/paths";

const DefaultErrorFallback = () => {
  const navigate = useNavigate();

  return (
    <Result
      style={{ marginTop: "10%" }}
      status="500"
      title="500"
      subTitle={`Sorry, something went wrong`}
      extra={
        <Button onClick={() => navigate(PATHS.HOME)} type="primary">
          Back Home
        </Button>
      }
    />
  );
};

export default DefaultErrorFallback;
